var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("modal"),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [_c("router-view")], 1),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fadePro" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showProgress,
                expression: "showProgress"
              }
            ],
            staticClass: "modal",
            attrs: { id: "myModal" },
            on: { click: _vm.closePopup }
          },
          [
            _c("div"),
            _vm._v(" "),
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "loader" })
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fadePopup" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.popupVisible,
                expression: "popupVisible"
              }
            ],
            attrs: { id: "myModalPopup" },
            on: { click: _vm.clickOut }
          },
          [
            _c("div", { attrs: { id: "back-popup" } }),
            _vm._v(" "),
            _c("div", { staticClass: "modal-content-mainpopup" }, [
              _c("div", { attrs: { id: "textoContainer-mainpopup" } }, [
                _c("p", { attrs: { id: "texto-mainpopup" } }, [
                  _vm._v(_vm._s(_vm.popupTxt))
                ])
              ]),
              _vm._v(" "),
              _c("div", { attrs: { id: "btnContainer-mainpopup" } }, [
                _c(
                  "button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.popupTxtBtnCancelVisible,
                        expression: "popupTxtBtnCancelVisible"
                      }
                    ],
                    attrs: { id: "mainpopupBtn1" },
                    on: { click: _vm.btnCancel }
                  },
                  [_vm._v(_vm._s(_vm.popupTxtBtnCancel))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  { attrs: { id: "mainpopupBtn2" }, on: { click: _vm.btnOk } },
                  [_vm._v(_vm._s(_vm.popupTxtBtnOk))]
                )
              ])
            ])
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bced26ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bced26ea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-bced26ea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module chunks = 0